import { useEffect, useState } from "react";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import axiosInstance from "../../api/axiosInstance.js";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialItemTable from "./MaterialItemTable.jsx";
import Model from "../../common/Model/index.js";
import { saveAs } from "file-saver";
import Loader from "../../common/Loader/index.js";
import { notify, Toast } from "../../common/Toast/index.js";
import CRMSelect from "../../common/CustomSelect/CRMSelect.jsx";
import { FaStarOfLife } from "react-icons/fa";
import FormFields from "../../common/FormFields/index.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";

const MaterialDetails = () => {
  const today = new Date().toISOString()?.split("T")[0];
  const permission = getUserMenuPermission(10);
  const customerPermission = getUserMenuPermission(6);
  const itemPermission = getUserMenuPermission(4);
  const navigate = useNavigate();
  const location = useLocation();
  const { materialQuotationData = {} } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [terms, setTerms] = useState([]);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [salesPersons, setSalesPersons] = useState([]);
  const [coatingParties, setCoatingParties] = useState([]);
  const [coatingColors, setCoatingColors] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [allItems, setAllItems] = useState([]);
  const [isCoatingModalOpen, setIsCoatingModalOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [isItemModalOpen, setIsItemModalOpen] = useState(false);
  const [isSameAsBilling, setIsSameAsBilling] = useState(true);
  const [coatingPartyModel, setCoatingPartyModel] = useState(false);
  const [items, setItems] = useState([
    {
      seQ_NO: 1,
      item_Code: "",
      item_Name: "",
      coating_Color_Id: "",
      panel_Size: "",
      qty: "",
      total_RfT: 0,
      rate: 0,
      amount: 0,
    },
  ]);
  const [formData, setFormData] = useState({
    proforma_No: 0,
    proforma_Date: today,
    customer_Id: "",
    company_Id: 3,
    sale_Id: "",
    coating_Party_Id: "",
    shipping_Address: "",
    remark: "",
    project: "",
    gross_Amount: 0,
    disc_Per: 0,
    disc_Amount: 0,
    gsT_Per: 18,
    gsT_Amount: 0,
    transportation: 0,
    packing_Charge: 0,
    net_Amount: "",
    stageId: null,
    reason: "",
  });
  const [isCoatingPartyEditing, setIsCoatingPartyEditing] = useState(false);

  const userId = localStorage.getItem("userId");
  const shouldShowCloseLostReason = (stageId) => {
    return stageId === 3;
  };
  const fields = [
    {
      name: "customer_Name",
      label: "Customer Name",
      type: "text",
      required: true,
      errorMessage: "Customer name is required",
    },
    { name: "mobile_No", label: "Contact No", type: "number" },
    { name: "firmName", label: "FirmName", type: "text" },
    { name: "address", label: " Address", type: "text" },
    { name: "gsT_No", label: "GST No", type: "text" },
  ];
  const CoatingPartyfields = [
    {
      name: "party_Name",
      label: "Party Name",
      type: "text",
      required: true,
      errorMessage: "Party name is required",
    },
    { name: "mobile_No", label: "Contact No", type: "number" },
    { name: "address", label: "Address", type: "text" },
    { name: "gsT_No", label: "GST No", type: "text" },
  ];

  useEffect(() => {
    if (
      materialQuotationData &&
      Object.keys(materialQuotationData).length > 0
    ) {
      setFormData((prev) => ({
        ...prev,
        proforma_No: materialQuotationData.proforma_No || 0,
        proforma_Date: materialQuotationData.proforma_Date,
        customer_Id: materialQuotationData.customer_Id || "",
        company_Id: materialQuotationData.company_Id || "",
        sale_Id: materialQuotationData.sale_Id || "",
        coating_Party_Id: materialQuotationData.coating_Party_Id || "",
        shipping_Address: materialQuotationData.shipping_Address || "",
        remark: materialQuotationData.remark || "",
        project: materialQuotationData.project || "",
        gross_Amount: materialQuotationData.gross_Amount || "",
        disc_Per: materialQuotationData.disc_Per || 0,
        disc_Amount: materialQuotationData.disc_Amount || 0,
        gsT_Per: materialQuotationData.gsT_Per || 0,
        gsT_Amount: materialQuotationData.gsT_Amount || 0,
        transportation: materialQuotationData.transportation || 0,
        packing_Charge: materialQuotationData.packing_Charge || 0,
        net_Amount: materialQuotationData.net_Amount || 0,
        stageId: materialQuotationData.stage_Id || 0,
        reason: materialQuotationData.reason ?? "",
      }));

      const updatedItems = (materialQuotationData.items || []).map((item) => {
        const matchedItem =
          Array.isArray(allItems) &&
          allItems.find((ai) => ai.item_Code === item.item_Code);
        return {
          ...item,
          item_Name: matchedItem ? matchedItem.item_Name : "",
        };
      });

      setItems(updatedItems);
      setTerms(materialQuotationData.terms || []);
      setIsEditing(true);
    }
  }, [materialQuotationData, allItems]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.customer_Id)
      newErrors.customer_Id = "Customer Name is required";
    if (!formData.sale_Id) newErrors.sale_Id = "Sale Person is required";
    if (!formData.proforma_Date)
      newErrors.proforma_Date = "Proforma Date is required";

    if (items.length === 0) {
      newErrors.items = "At least one item is required";
    } else {
      items.forEach((item, index) => {
        if (!item.item_Code)
          newErrors[`item_Code_${index}`] = "Item Code is required";
        if (!item.qty || item.qty <= 0)
          newErrors[`qty_${index}`] = "Quantity must be greater than 0";
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "proforma_No" ? parseInt(value, 10) || 0 : value,
    }));
  };
  const handleCoatingPartySubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        Party_Name: formData.party_Name,
        Mobile_No: formData.mobile_No,
        Address: formData.address,
        GST_No: formData.gsT_No,
        Is_Active: formData.is_Active ?? true,
      };

      const response = await axiosInstance.post(
        "MaterialQuotation/SaveCoatingParty",
        payload
      );

      notify("Coating Party added successfully!", "success");
      fetchDropdownData(
        "MaterialQuotation/GetAllCoatingParties",
        setCoatingParties
      );
      if (response?.data?.coating_Party_Id) {
        setFormData((prev) => ({
          ...prev,
          coating_Party_Id: response.data.coating_Party_Id,
        }));
      }

      setCoatingPartyModel(false);
    } catch (err) {
      console.error("Error saving coating party:", err);
      notify("Failed to add Coating Party", "error");
    }
  };

  const handleCustomerChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData((prev) => ({
        ...prev,
        customer_Id: "",
        shipping_Address: "",
      }));
      setIsSameAsBilling(false);
      return;
    }

    const customerId = selectedOption.value;
    if (customerId === "add-new") {
      setFormData({
        customer_Name: "",
        mobile_No: "",
        firmName: "",
        address: "",
        gsT_No: "",
        customer_Id: "",
        shipping_Address: "",
      });
      setIsSameAsBilling(false);
      setIsModelOpen(true);
      return;
    }

    const customer = customers.find(
      (c) => c.customer_Id === Number(customerId)
    );
    const address = customer?.address || "";
    setFormData((prev) => ({
      ...prev,
      customer_Id: Number(customerId),
      shipping_Address: address,
    }));
    setIsSameAsBilling(true);
  };
  const handleSameAsBillingChange = () => {
    const selectedCustomer = customers.find(
      (c) => c.customer_Id === Number(formData.customer_Id)
    );

    const address = selectedCustomer?.address || "";

    setIsSameAsBilling((prev) => {
      const newValue = !prev;
      if (newValue) {
        setFormData((prevForm) => ({
          ...prevForm,
          shipping_Address: address,
        }));
      }
      return newValue;
    });
  };

  useEffect(() => {
    fetchDropdownData("Customer/GetAll", setCustomers);
    fetchDropdownData("User/GetAllUser ", setSalesPersons);
    fetchDropdownData(
      "MaterialQuotation/GetAllCoatingParties",
      setCoatingParties
    );
    fetchDropdownData(
      "MaterialQuotation/GetAllCoatingColors",
      setCoatingColors
    );
    fetchItemsData();
    if (
      materialQuotationData &&
      Object.keys(materialQuotationData).length > 0
    ) {
      fetchTermsData(
        materialQuotationData.proforma_No,
        materialQuotationData.terms
      );
    } else {
      fetchTermsData(0);
    }
  }, []);

  const fetchTermsData = async (proforma_No = 0, existingTerms = []) => {
    try {
      setLoading(true);

      if (proforma_No === 0) {
        const response = await axiosInstance.get("Terms/GetAll");
        const formattedTerms = response.data.map((term, index) => ({
          seq_No: index + 1,
          term_Name: term.term_Name,
          term_Id: term.term_Id,
          isEditing: false,
        }));
        setTerms(formattedTerms);
      } else {
        setTerms(existingTerms || []);
      }
    } catch (error) {
      console.error("Error fetching terms:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchItemsData = async () => {
    try {
      const response = await axiosInstance.get("Item/GetAll");
      setAllItems(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  const totalAmountBeforeTax = items.reduce(
    (sum, item) => sum + (Number(item.amount) || 0),
    0
  );

  const discount =
    (Number(totalAmountBeforeTax) * (Number(formData.disc_Per) || 0)) / 100;

  const total = totalAmountBeforeTax - discount;

  const gstAmount = (total * (Number(formData.gsT_Per) || 0)) / 100;

  const grandTotal =
    total +
    gstAmount +
    (Number(formData.transportation) || 0) +
    (Number(formData.packing_Charge) || 0);

  const handleItemSelect = (index, eventOrOption, fieldName = null) => {
    const updatedItems = [...items];

    if (fieldName) {
      if (eventOrOption === null) {
        updatedItems[index] = { ...updatedItems[index], [fieldName]: "" };
      } else {
        const value =
          eventOrOption?.target?.value !== undefined
            ? eventOrOption.target.value
            : eventOrOption.value;

        if (fieldName === "coating_Color_Id" && value === "add-new") {
          if (!formData.coating_Party_Id) {
            notify(
              "Please select a Coating Party before adding a new Coating Color",
              "error"
            );
            return;
          }
          setIsCoatingModalOpen(true);
          return;
        } else if (fieldName === "item_Code" && value === "add-newItem") {
          setIsItemModalOpen(true);
          return;
        }

        if (fieldName === "item_Code") {
          const selectedItem = allItems.find(
            (item) => String(item.item_Code) === String(value)
          );
          if (!selectedItem) return;

          updatedItems[index] = {
            ...updatedItems[index],
            item_Code: selectedItem.item_Code || "",
            item_Name: selectedItem.item_Name || "",
            rate: selectedItem.item_Rate || 0,
          };
        } else {
          updatedItems[index] = {
            ...updatedItems[index],
            [fieldName]: fieldName === "rate" ? parseFloat(value) || 0 : value,
          };
        }
      }
    } else {
      const { name, value } = eventOrOption.target;

      updatedItems[index] = {
        ...updatedItems[index],
        [name]: value,
      };
    }

    const panelSize = parseFloat(updatedItems[index].panel_Size) || 0;
    const qty = parseFloat(updatedItems[index].qty) || 0;

    if (panelSize > 0) {
      updatedItems[index].total_RfT = (panelSize * qty) / 304.8;
      updatedItems[index].amount =
        updatedItems[index].total_RfT * (parseFloat(updatedItems[index].rate) || 0);
    } else {
      updatedItems[index].total_RfT = 0;
      updatedItems[index].amount = qty * (parseFloat(updatedItems[index].rate) || 0);
    }

    setItems([...updatedItems]);
  };

  const handleItemDelete = async (index, item_Code, seQ_NO) => {
    const proforma_No = formData.proforma_No;

    try {
      const updatedItems = [...items];
      await axiosInstance.delete(
        `MaterialQuotation/DeleteItem/${proforma_No}/${item_Code}/${seQ_NO}`
      );
      updatedItems.splice(index, 1);
      setItems(updatedItems);
      notify("Item deleted successfully", "success");
    } catch (error) {
      notify("Error deleting item", "error");
      console.error("Error deleting item:", error);
    }
  };

  const fetchDropdownData = async (endpoint, setData, dataKey) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(endpoint);
      if (dataKey) {
        setData(response.data[dataKey] || []);
      } else {
        setData(response.data || []);
      }
    } catch (error) {
      console.error(`Error fetching data from ${endpoint}:`, error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddTerm = () => {
    setTerms((prevTerms) => {
      if (formData.proforma_No === 0) {
        const newTermId =
          prevTerms.length > 0
            ? prevTerms[prevTerms.length - 1].term_Id + 1
            : 1;
        return [
          ...prevTerms,
          { term_Id: newTermId, term_Name: "", isEditing: true },
        ];
      } else {
        const newSeqNo =
          prevTerms.length > 0 ? prevTerms[prevTerms.length - 1].seq_No + 1 : 1;
        return [
          ...prevTerms,
          { seq_No: newSeqNo, term_Name: "", isEditing: true, isNew: true },
        ];
      }
    });
  };

  const handleEditTerms = (id) => {
    setTerms((prevTerms) =>
      prevTerms.map((term) =>
        (formData.proforma_No === 0 ? term.term_Id : term.seq_No) === id
          ? { ...term, isEditing: true }
          : term
      )
    );
  };
  const handleDeleteTerm = async (seq_No, isNew) => {
    const proforma_No = formData.proforma_No;
    if (proforma_No === 0) {
      setTerms((prevTerms) =>
        prevTerms.filter((term) => term.term_Id !== seq_No)
      );
    } else {
      if (isNew === true) {
        setTerms((prevTerms) =>
          prevTerms.filter((term) => term.seq_No !== seq_No)
        );
        return;
      }
      try {
        await axiosInstance.delete(
          `MaterialQuotation/DeleteTerm/${proforma_No}/${seq_No}`
        );
        setTerms((prevTerms) =>
          prevTerms.filter((term) => term.seq_No !== seq_No)
        );
      } catch (error) {
        console.error("Error deleting term:", error);
      }
    }
  };

  const handleTermChange = (index, event) => {
    const { name, value } = event.target;
    setTerms((prevTerms) =>
      prevTerms.map((term, i) =>
        i === index ? { ...term, [name]: value } : term
      )
    );
  };

  const handleSaveOrUpdate = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    const payload = {
      Proforma_No: Number(formData.proforma_No) || 0,
      Customer_Id: Number(formData.customer_Id),
      Company_Id: Number(formData.company_Id),
      Sale_Id: Number(formData.sale_Id),
      Coating_Party_Id: Number(formData.coating_Party_Id),
      shipping_Address: formData.shipping_Address,
      remark: formData.remark,
      project: formData.project,
      Proforma_Date: formData.proforma_Date,
      Modified_By: Number(formData.modifiedBy) || 0,
      Gross_Amount: Number(totalAmountBeforeTax),
      Disc_Per: Number(formData.disc_Per),
      Disc_Amount: Number(discount),
      GST_Per: Number(formData.gsT_Per),
      GST_Amount: Number(gstAmount),
      Transportation: Number(formData.transportation),
      Packing_Charge: Number(formData.packing_Charge),
      Net_Amount: Number(grandTotal),
      CreatedBy: userId,
      ...(Number(formData.stageId) === 3 && {
        Reason: formData.reason,
      }),

      Items: items.map((item) => ({
        Item_code: Number(item.item_Code),
        Coating_Color_Id:
          item.coating_Color_Id && !isNaN(item.coating_Color_Id)
            ? parseInt(item.coating_Color_Id)
            : null,
        Qty: Number(item.qty),
        Panel_size: item.panel_Size,
        Total_RfT: Number(item.total_RfT),
        Rate: Number(item.rate),
        Amount: Number(item.amount),
        seQ_NO: item.seQ_NO,
      })),
      Terms: terms.map((term) => ({
        seq_No: Number(formData.proforma_No) > 0 ? Number(term.seq_No) : 0,
        Term_Name: term.term_Name,
        Proforma_No: Number(formData.proforma_No),
      })),
    };

    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "MaterialQuotation/saveUpdateproforma",
        payload
      );

      if (response?.data) {
        notify(
          isEditing
            ? "Material Quotation updated successfully!"
            : "Material Quotation added successfully!",
          "success"
        );
        setTimeout(() => navigate("/quotes/material-quotation"), 1000);
      } else {
        notify("Something went wrong. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error saving quotation:", error);
      notify("Failed to save Material Quotation.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        Customer_Name: formData.customer_Name,
        Firm_Name: formData.firmName,
        Mobile_No: formData.mobile_No,
        Address: formData.address,
        GST_No: formData.gsT_No,
      };

      await axiosInstance.post("Customer/SaveOrUpdate", payload);
      fetchDropdownData("Customer/GetAll", setCustomers);
      setIsModelOpen(false);
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  const onClear = () => {
    setIsModelOpen(false);
  };

  const handlePrint = async (proforma_No) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `MaterialQuotation/materialQuotePrint/${proforma_No}`,
        { responseType: "blob" }
      );

      if (response.status === 200) {
        const blob = new Blob([response.data], { type: "application/pdf" });

        const customer = customers.find(
          (c) => c.customer_Id === Number(formData.customer_Id)
        );
        const customerName =
          customer?.customer_Name?.replace(/\s+/g, "_") || "Customer";

        saveAs(blob, `PI_${proforma_No}_${customerName}.pdf`);

        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        alert("Failed to generate PDF. Please try again later.");
      }
    } catch (error) {
      console.error("Error printing material quotation:", error);
      const errorMessage =
        error.response?.data?.message || "Unknown error occurred.";

      if (errorMessage.includes("Select.HtmlToPdf")) {
        alert(
          "PDF generation is currently unavailable. Please contact support."
        );
      } else {
        alert(`An error occurred while printing: ${errorMessage}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const options = [
    ...customers.map((cus) => ({
      value: cus.customer_Id?.toString() || "",
      label: cus.customer_Name || "Unnamed Customer",
    })),
    ...(customerPermission.isInsert ? [{ value: "add-new", label: "+ Add New Customer" }] : []),
  ];
  const saleOptions = [
    ...salesPersons.map((per) => ({
      value: per.sale_Person_Id?.toString() || "",
      label: per.Sale_Person_Name || "Unnamed Sales",
    })),
  ];
  const coatingOptions = [
    ...coatingParties.map((coat) => ({
      value: coat.coating_Party_Id?.toString() || "",
      label: coat.party_Name || "Unnamed Coating",
    })),
    ...(permission.isInsert ? [{ value: "add-newCoatingParty", label: "+ Add New Coating Party" }] : []),
  ];


  const handleCoatingPartyEdit = async (id) => {
    try {
      const { data } = await axiosInstance.get(
        `MaterialQuotation/GetCoatingPartyById/${id}`
      );
      setFormData((prev) => ({
        ...prev,
        ...data,
        coating_Party_Id: Number(id),
      }));
      setIsCoatingPartyEditing(true);
      setCoatingPartyModel(true);
    } catch (err) {
      console.error(err);
    }
  };
  const handleUpdateCoatingParty = async () => {
    try {
      await axiosInstance.post("MaterialQuotation/UpdateCoatingParty", {
        Coating_Party_Id: formData.coating_Party_Id,
        Party_Name: formData.party_Name,
        Mobile_No: formData.mobile_No,
        Address: formData.address,
        Gst_No: formData.gsT_No,
      });

      notify("Coating Party Updated Successfully!", "success");
      fetchDropdownData(
        "MaterialQuotation/GetAllCoatingParties",
        setCoatingParties
      );
      setCoatingPartyModel(false);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Toast />
      <div className="min-h-screen p-4 md:p-8 bg-slate-50/50">
        {loading ? (
          <div className="flex items-center justify-center min-h-[60vh]">
            <Loader />
          </div>
        ) : (
          <div >
            {/* Header section */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 gap-4">
              <div className="flex flex-col">
                <h1 className="text-xl font-black text-slate-800 tracking-tight uppercase">Material Details</h1>
                <p className="text-[11px] text-slate-400 font-bold uppercase tracking-wider mt-0.5">Manage material proforma invoice and tracking</p>
              </div>
              <button
                className="px-4 py-2 bg-white hover:bg-slate-50 text-slate-700 text-[11px] font-black uppercase tracking-widest rounded-xl border border-slate-200 shadow-sm transition-all flex items-center gap-2 active:scale-95"
                onClick={() => navigate(`/quotes/material-quotation`)}
              >
                <span className="text-lg">←</span> Back to List
              </button>
            </div>

            <form className="space-y-4" onSubmit={handleSaveOrUpdate}>
              {/* Primary Attributes Card */}
              <div className="bg-white p-6 rounded-3xl shadow-xl shadow-slate-200/40 border border-slate-100 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary/40 to-primary"></div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex flex-col space-y-2">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1 flex items-center">
                      Customer
                      <FaStarOfLife className="text-red-400 ml-2 w-1.5 h-1.5" />
                    </label>
                    <CRMSelect
                      options={options}
                      value={formData.customer_Id ? options.find(option => Number(option.value) === Number(formData.customer_Id)) || null : null}
                      isClearable
                      isSearchable
                      onChange={handleCustomerChange}
                      menuPortalTarget={document.body}
                      error={errors.customer_Id}
                    />
                    {errors.customer_Id && (
                      <p className="text-red-500 text-[10px] font-black mt-1 ml-1 uppercase">{errors.customer_Id}</p>
                    )}
                  </div>

                  <div className="flex flex-col space-y-2">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                      Company
                    </label>
                    <input
                      type="text"
                      value="H-Line"
                      disabled
                      className="w-full rounded-xl border border-slate-100 bg-slate-50/50 px-4 py-2.5 text-slate-400 font-bold cursor-not-allowed text-sm"
                    />
                  </div>

                  <div className="flex flex-col space-y-2">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1 flex items-center">
                      Sales Person
                      <FaStarOfLife className="text-red-400 ml-2 w-1.5 h-1.5" />
                    </label>
                    <CRMSelect
                      options={saleOptions}
                      value={formData.sale_Id ? saleOptions.find(option => Number(option.value) === Number(formData.sale_Id)) || null : null}
                      isClearable
                      isSearchable
                      menuPortalTarget={document.body}
                      onChange={(opt) => setFormData(prev => ({ ...prev, sale_Id: opt ? opt.value : "" }))}
                      error={errors.sale_Id}
                    />
                    {errors.sale_Id && (
                      <p className="text-red-500 text-[10px] font-black mt-1 ml-1 uppercase">{errors.sale_Id}</p>
                    )}
                  </div>

                  <div className="flex flex-col space-y-2">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                      Coating Party
                    </label>
                    <div className="flex gap-2 items-center">
                      <div className="flex-1">
                        <CRMSelect
                          options={coatingOptions}
                          value={formData.coating_Party_Id ? coatingOptions.find(option => Number(option.value) === Number(formData.coating_Party_Id)) || null : null}
                          isClearable
                          isSearchable
                          onChange={(option) => {
                            if (option?.value === "add-newCoatingParty") {
                              setFormData({ party_Name: "", mobile_No: "", address: "", gsT_No: "" });
                              setCoatingPartyModel(true);
                            } else {
                              setFormData(prev => ({ ...prev, coating_Party_Id: option ? option.value : "" }));
                            }
                          }}
                          menuPortalTarget={document.body}
                        />
                      </div>
                      {formData.coating_Party_Id && (
                        <button
                          type="button"
                          className="p-2.5 bg-primary/5 text-primary rounded-xl hover:bg-primary hover:text-white transition-all shadow-sm flex-shrink-0"
                          onClick={() => handleCoatingPartyEdit(formData.coating_Party_Id)}
                        >
                          <MdModeEdit size={18} />
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="flex flex-col space-y-2">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                      Project Reference
                    </label>
                    <input
                      type="text"
                      value={formData.project}
                      onChange={handleInputChange}
                      name="project"
                      placeholder="Enter project name or site location..."
                      className="w-full rounded-xl border border-slate-200 bg-white px-4 py-2.5 outline-none transition-all hover:border-primary/30 focus:border-primary font-bold text-sm"
                    />
                  </div>
                </div>
              </div>

              {/* Delivery & Documentation Card */}
              <div className="bg-white p-6 rounded-3xl shadow-xl shadow-slate-200/40 border border-slate-100">
                <div className="flex flex-col gap-6">
                  <div className="flex items-center gap-4 bg-slate-50/50 p-3 rounded-xl border border-slate-100 w-fit">
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        id="isSameAsBilling"
                        type="checkbox"
                        className="sr-only peer"
                        checked={isSameAsBilling}
                        onChange={handleSameAsBillingChange}
                      />
                      <div className="w-10 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary"></div>
                      <span className="ml-3 text-[11px] font-bold text-slate-600 uppercase tracking-wide">Copy Billing Address</span>
                    </label>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="flex flex-col space-y-2">
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                        Shipping Address
                      </label>
                      <textarea
                        rows={4}
                        className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 outline-none transition-all hover:border-primary/30 focus:border-primary font-bold text-sm leading-relaxed disabled:bg-slate-50 disabled:text-slate-400"
                        value={formData.shipping_Address}
                        onChange={(e) => {
                          setFormData(prev => ({ ...prev, shipping_Address: e.target.value }));
                          setIsSameAsBilling(false);
                        }}
                        disabled={isSameAsBilling}
                        placeholder="Complete site delivery address..."
                      />
                    </div>

                    <div className="space-y-4">
                      <div className="flex flex-col space-y-2">
                        <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                          Proforma No
                        </label>
                        <input
                          type="text"
                          className="w-full rounded-xl border border-slate-100 bg-slate-50/50 px-4 py-2.5 text-slate-400 font-bold cursor-not-allowed text-sm"
                          name="proforma_No"
                          value={formData.proforma_No}
                          disabled
                        />
                      </div>

                      <div className="flex flex-col space-y-2">
                        <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1 flex items-center">
                          Proforma Date
                          <FaStarOfLife className="text-red-400 ml-2 w-1.5 h-1.5" />
                        </label>
                        <input
                          type="date"
                          className={`w-full rounded-xl border px-4 py-2.5 outline-none transition-all font-bold text-sm ${errors.proforma_Date
                            ? "border-red-300 bg-red-50/20"
                            : "border-slate-200 bg-white hover:border-primary/30 focus:border-primary"
                            }`}
                          name="proforma_Date"
                          value={formData.proforma_Date?.split("T")[0]}
                          onChange={handleInputChange}
                          onFocus={(e) => e.target.showPicker()}
                        />
                        {errors.proforma_Date && (
                          <p className="text-red-500 text-[10px] font-black mt-1 ml-1 uppercase">{errors.proforma_Date}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Items Card */}
              <div className="bg-white rounded-3xl shadow-xl shadow-slate-200/40 border border-slate-100 overflow-hidden">
                <div className="bg-slate-50/50 px-6 py-4 border-b border-slate-100">
                  <h2 className="text-[11px] font-black text-slate-700 uppercase tracking-widest">Inventory & Items</h2>
                </div>
                <div className="p-2">
                  <MaterialItemTable
                    items={items}
                    setItems={setItems}
                    allItems={allItems}
                    setAllItems={setAllItems}
                    coatingColors={coatingColors}
                    setCoatingColors={setCoatingColors}
                    handleItemSelect={handleItemSelect}
                    handleItemDelete={handleItemDelete}
                    selectedCoatingPartyId={formData.coating_Party_Id}
                    isCoatingModalOpen={isCoatingModalOpen}
                    setIsCoatingModalOpen={setIsCoatingModalOpen}
                    setIsItemModalOpen={setIsItemModalOpen}
                    isItemModalOpen={isItemModalOpen}
                    errors={errors}
                    validateForm={validateForm}
                    isEditing={isEditing}
                    fetchDropdownData={fetchDropdownData}
                    permission={permission}
                    itemPermission={itemPermission}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Terms List Card */}
                <div className="bg-white rounded-3xl shadow-xl shadow-slate-200/40 border border-slate-100 overflow-hidden flex flex-col">
                  <div className="bg-slate-50/50 px-6 py-4 border-b border-slate-100 flex justify-between items-center">
                    <h2 className="text-[11px] font-black text-slate-700 uppercase tracking-widest">Terms & Conditions</h2>
                    <button
                      type="button"
                      className="text-[9px] font-black text-primary bg-primary/10 px-3 py-1.5 rounded-full hover:bg-primary hover:text-white transition-all uppercase tracking-widest"
                      onClick={handleAddTerm}
                    >
                      + ADD NEW
                    </button>
                  </div>
                  <div className="p-8 space-y-4 max-h-[500px] overflow-y-auto">
                    {terms?.length === 0 && (
                      <div className="flex flex-col items-center justify-center py-10 text-slate-300">
                        <p className="text-xs font-bold uppercase tracking-widest">No terms defined</p>
                      </div>
                    )}
                    {terms.map((term, index) => (
                      <div key={index} className="flex items-center gap-4 bg-slate-50 rounded-2xl p-4 border border-slate-100/50 group transition-all hover:bg-white hover:shadow-md hover:border-primary/20">
                        <textarea
                          name="term_Name"
                          value={term.term_Name || ""}
                          onChange={(e) => handleTermChange(index, e)}
                          disabled={!term.isEditing}
                          rows={2}
                          className={`flex-grow bg-transparent text-sm font-semibold leading-relaxed outline-none transition-all resize-none ${term.isEditing ? "text-primary border-b border-primary/20 pb-1" : "text-slate-600"}`}
                          placeholder="Type term text here..."
                        />
                        <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                          <button
                            type="button"
                            className={`p-2 rounded-lg transition-all ${term.isEditing ? "bg-primary text-white" : "bg-white text-slate-400 hover:text-primary shadow-sm"}`}
                            onClick={() => handleEditTerms(formData.proforma_No === 0 ? term.term_Id : term.seq_No)}
                          >
                            <MdModeEdit size={18} />
                          </button>
                          <button
                            type="button"
                            className="p-2 bg-white text-slate-400 hover:text-red-500 rounded-lg shadow-sm transition-all"
                            onClick={() => handleDeleteTerm(formData.proforma_No === 0 ? term.term_Id : term.seq_No, term.isNew)}
                          >
                            <MdDeleteForever size={18} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Totals / Calculation Card */}
                <div className="bg-white rounded-3xl shadow-xl shadow-slate-200/40 border border-slate-100 overflow-hidden flex flex-col">
                  <div className="bg-slate-50/50 px-6 py-4 border-b border-slate-100">
                    <h2 className="text-[11px] font-black text-slate-700 uppercase tracking-widest">Summary & Totals</h2>
                  </div>
                  <div className="p-6 space-y-4">
                    <div className="flex justify-between items-center px-1">
                      <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Untaxed Amount</span>
                      <span className="text-base font-black text-slate-700 font-mono">₹{totalAmountBeforeTax.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                    </div>

                    <div className="flex flex-col bg-slate-50/50 rounded-xl p-4 border border-slate-100 space-y-3">
                      <div className="flex justify-between items-center group">
                        <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest flex items-center gap-2">
                          Discount <span className="text-[9px] text-slate-300 font-bold">(%)</span>
                        </label>
                        <div className="flex items-center gap-3">
                          <input
                            type="text"
                            value={formData.disc_Per}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "" || /^\d*\.?\d*$/.test(val)) setFormData(prev => ({ ...prev, disc_Per: Number(val) || 0 }));
                            }}
                            className="w-16 bg-white border border-slate-200 rounded-lg px-2 py-1.5 text-right font-bold text-slate-600 outline-none focus:border-primary transition-all text-xs"
                          />
                          <span className="text-red-400 font-black text-xs min-w-[70px] text-right font-mono">- ₹{discount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                        </div>
                      </div>

                      <div className="flex justify-between items-center">
                        <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
                          GST <span className="text-[9px] text-slate-300 font-bold">(%)</span>
                        </label>
                        <div className="flex items-center gap-3">
                          <input
                            type="text"
                            value={formData.gsT_Per}
                            onChange={(e) => setFormData(prev => ({ ...prev, gsT_Per: Number(e.target.value) }))}
                            className="w-16 bg-white border border-slate-200 rounded-lg px-2 py-1.5 text-right font-bold text-slate-600 outline-none focus:border-primary transition-all text-xs"
                          />
                          <span className="text-blue-500 font-black text-xs min-w-[70px] text-right font-mono">+ ₹{gstAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                        </div>
                      </div>

                      <div className="h-px bg-slate-200/50"></div>

                      <div className="grid grid-cols-2 gap-3">
                        <div className="flex flex-col gap-1.5">
                          <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-1">Transportation</label>
                          <input
                            type="text"
                            value={formData.transportation}
                            onChange={(e) => setFormData(prev => ({ ...prev, transportation: Number(e.target.value) }))}
                            className="bg-white border border-slate-200 rounded-lg px-3 py-2 font-bold text-slate-600 outline-none focus:border-primary transition-all text-xs"
                          />
                        </div>
                        <div className="flex flex-col gap-1.5">
                          <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-1">Packing</label>
                          <input
                            type="text"
                            value={formData.packing_Charge}
                            onChange={(e) => setFormData(prev => ({ ...prev, packing_Charge: Number(e.target.value) }))}
                            className="bg-white border border-slate-200 rounded-lg px-3 py-2 font-bold text-slate-600 outline-none focus:border-primary transition-all text-xs"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="bg-primary/5 rounded-2xl p-6 border border-primary/10 shadow-sm relative overflow-hidden group">
                      <div className="absolute top-0 right-0 p-8 opacity-5 group-hover:scale-110 transition-transform">
                        <span className="text-6xl font-black text-primary">₹</span>
                      </div>
                      <div className="relative z-10 flex flex-col items-center text-center">
                        <span className="text-[9px] font-black text-primary uppercase tracking-[0.3em] mb-2">Total Payable</span>
                        <span className="text-3xl font-black text-primary tracking-tighter antialiased font-mono">₹{grandTotal?.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Buttons & Remarks */}
              <div className="flex flex-col gap-6 pt-4">
                <div className="bg-white rounded-3xl shadow-xl shadow-slate-200/30 border border-slate-100 overflow-hidden p-6">
                  <h2 className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3 ml-1">Internal Remarks</h2>
                  <textarea
                    id="remark"
                    rows="3"
                    name="remark"
                    value={formData.remark}
                    onChange={handleInputChange}
                    className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all placeholder:text-slate-300 font-bold text-sm leading-relaxed"
                    placeholder="Click to add private notes or specific instructions..."
                  />
                </div>

                <div className="flex flex-col md:flex-row items-center gap-4 pb-12">
                  {(isEditing ? permission.isUpdate : permission.isInsert) && (
                    <button
                      className="w-full md:w-auto px-8 py-3 bg-primary text-white text-[11px] font-black uppercase tracking-widest rounded-xl shadow-lg shadow-primary/20 hover:shadow-xl hover:translate-x-1 transition-all active:scale-[0.98] flex items-center justify-center gap-3"
                      type="submit"
                    >
                      <span>{isEditing ? "Update Invoice" : "Generate Proforma"}</span>
                      <span className="text-lg">→</span>
                    </button>
                  )}
                  {isEditing && (
                    <button
                      type="button"
                      className="w-full md:w-auto px-6 py-3 bg-white border border-slate-200 text-slate-700 text-[11px] font-black uppercase tracking-widest rounded-xl hover:bg-slate-50 transition-all active:scale-[0.98] flex items-center justify-center gap-2 shadow-sm"
                      onClick={() => handlePrint(formData.proforma_No)}
                    >
                      <span>Print Document</span>
                    </button>
                  )}
                  <button
                    type="button"
                    className="w-full md:w-auto px-8 py-3 bg-slate-100 text-slate-500 text-[11px] font-black uppercase tracking-widest rounded-xl hover:bg-slate-200 transition-all active:scale-[0.98]"
                    onClick={() => navigate(-1)}
                  >
                    Discard Changes
                  </button>
                </div>
              </div>
            </form>

            <Model
              isOpen={isModelOpen}
              onClose={() => setIsModelOpen(false)}
              name="Add Customer"
            >
              <FormFields
                onSubmit={handleSubmit}
                setIsModelOpen={setIsModelOpen}
                formData={formData}
                handleInputChange={handleInputChange}
                fields={fields}
                onClear={onClear}
              />
            </Model>
            <Model
              isOpen={coatingPartyModel}
              onClose={() => {
                setCoatingPartyModel(false);
                setIsCoatingPartyEditing(false);
              }}
              name={isEditing ? "Edit Coating Party" : "Add Coating Party"}
            >
              <FormFields
                formData={formData}
                fields={CoatingPartyfields}
                handleInputChange={handleInputChange}
                setIsModelOpen={setCoatingPartyModel}
                onClear={() => {
                  setCoatingPartyModel(false);
                  setIsCoatingPartyEditing(false);
                }}
                onSubmit={
                  isCoatingPartyEditing
                    ? handleUpdateCoatingParty
                    : handleCoatingPartySubmit
                }
                isEditing={isCoatingPartyEditing}
              />
            </Model>
          </div>
        )}
      </div>
    </>
  );
};

export default MaterialDetails;
